/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitDetailsAliases {
  BREADCRUMB_0 = 'breadcrumb-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  DECK_FORMS = 'deck-forms',
  FETCH_FORMS = 'fetch-forms',
  FETCH_VISIT_DATA = 'fetch-visit-data',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_DATE = 'field-date',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_FILLING_DATE = 'field-filling-date',
  FIELD_FORMULARY = 'field-formulary',
  FIELD_NAME_AUDITOR = 'field-name-auditor',
  FIELD_STATUS = 'field-status',
  FIELD_TYPE = 'field-type',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_CUSTOM_CARD_VISIT_FORM = 'hpms-custom-card-visit-form',
  LAYOUT_0 = 'layout-0',
  LAYOUT_2 = 'layout-2',
  LAYOUT_ESTABLISHMENT_DATA = 'layout-establishment-data',
  LAYOUT_FORMS = 'layout-forms',
  PANEL_2 = 'panel-2',
  PANEL_ESTABLISHMENT_DATA = 'panel-establishment-data',
  PANEL_MAIN = 'panel-main',
  PANEL_VISIT_DATA = 'panel-visit-data',
  PDF_VIEWER = 'pdf-viewer',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_DATE = 'text-date',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_FILLING_DATE = 'text-filling-date',
  TEXT_NAME_AUDITOR = 'text-name-auditor',
  TEXT_STATUS = 'text-status',
  TEXT_TYPE = 'text-type',
}
export { TechnicalVisitDetailsAliases };
